.fp-layout
  .fp-layout--body
    PageVue
      template(v-slot:body)
        ClubSelectionVue
